import Component from '../inherited/Component'

export default class ImageZoom extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this._triggerElem = this._elem.querySelector('[data-image-zoom-trigger]') ? this._elem.querySelector('[data-image-zoom-trigger]') : this._elem
  }

  mount () {
    let isActive = false

    this._elem.addEventListener('click', (e) => {
        if(e.target == this._triggerElem) return
        if(isActive) {
            isActive = false
            this._elem.classList.toggle('active')
        }
    })
    
    this._triggerElem.addEventListener('click', () => {
      this._elem.classList.toggle('active')
      isActive = !isActive
    })

    this._elem.addEventListener('mousemove', (e) => {
      if(isActive) {
        this._elem.style.backgroundPositionX = e.offsetX / this._elem.clientWidth * 100 + '%'
        this._elem.style.backgroundPositionY = e.offsetY / this._elem.clientHeight * 100 + '%'
      }
    })

    this._elem.addEventListener('mouseleave', () => {
      this._elem.classList.remove('active')
      isActive = false
    })
  }
}